var map = {
	"./appcharts": 62793,
	"./appcharts.vue": 62793,
	"./catalogservices": 83165,
	"./catalogservices.vue": 83165,
	"./configurations": 63857,
	"./configurations.vue": 63857,
	"./namespaces": 22736,
	"./namespaces.vue": 22736,
	"./services": 88439,
	"./services.vue": 88439
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66060;
module.exports = webpackAsyncContext;